import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table } from "antd";

class SpaceRoomCourseListModal extends Component {
  state = {
    loading: false,
    item: null,
    items: [],
  };

  static propTypes = {
    rooms: PropTypes.array.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "空間編號",
        dataIndex: "RoomCode",
        width: 30,
      },
      {
        title: "時間",
        dataIndex: "WeekTime",
        width: 50,
      },
      {
        title: "課名",
        dataIndex: "CourseName",
        width: 40,
        responsive: ["md"],
      },
      {
        title: "授課老師",
        dataIndex: "LecturerName",
        width: 30,
        responsive: ["md"],
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading } = this.state;
    const { rooms } = this.props;
    console.log(rooms);
    return (
      <Card>
        <Table
          dataSource={rooms}
          columns={this.columns}
          loading={loading}
          scroll={{ y: 460 }}
          width="70%"
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceRoomCourseListModal);
